import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  containerStyle: {
    flexDirection: 'row',
    marginVertical: 12.5,
  },
  labelStyle: {
    fontSize: 16.6,
    lineHeight: 23,
    flexGrow: 1,
  },
  valueStyle: {
    fontSize: 16.6,
    lineHeight: 23,
  },
  valueViewStyle: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    flexGrow: 1,
  },
});
